'use strict';

angular.module('licensure.services')
    .factory('FIPSLookup', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/fipslookup', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByPostalCode: function (postalCode) {
                var d = $q.defer();

                if (postalCode.length > 0) {
                    $http
                        .get(apiLocation + '/api/fipslookup', {
                            params: {
                                postalCode: postalCode
                            }
                        })
                        .then(function (response) {
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            // handle error
                        });
                } else {
                    d.resolve([]);
                }

                return d.promise;
            }
        }
    }])
;